import React from 'react';

export function AnimatedNumber({ value }) {
    const [displayValue, setDisplayValue] = React.useState(0);

    React.useEffect(() => {
        const end = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
        if (isNaN(end) || end === null || end === undefined) {
            setDisplayValue(value);
            return;
        }

        const duration = 1500;
        let startTime = null;
        let animationFrame;

        const animate = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const progress = Math.min((currentTime - startTime) / duration, 1);
            
            // easeOutQuart
            const ease = 1 - Math.pow(1 - progress, 4);
            const current = Math.floor(end * ease);
            setDisplayValue(current);
            
            if (progress < 1) {
                animationFrame = requestAnimationFrame(animate);
            } else {
                setDisplayValue(end);
            }
        };
        
        animationFrame = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(animationFrame);
    }, [value]);

    if (isNaN(parseFloat(value))) return value || '—';
    return displayValue.toLocaleString();
}


export function KpiCard({ label, val, sub, icon, accent }) {
    return (
        <div
            className="relative bg-white rounded-2xl px-4 pt-4 pb-3 overflow-hidden flex flex-col gap-1 border border-slate-100"
            style={{ boxShadow: '0 1px 4px rgba(10,37,64,0.06)' }}
        >
            <div className="absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl" style={{ background: accent.bar }} />
            <div
                className="w-7 h-7 rounded-lg flex items-center justify-center mb-1"
                style={{ background: accent.bg, color: accent.text }}
            >
                {React.cloneElement(icon, { sx: { fontSize: 15 } })}
            </div>
            <div
                className="text-2xl font-black tracking-tight"
                style={{ color: '#0a2540', fontFamily: '"DM Mono", monospace' }}
            >
                <AnimatedNumber value={val} />
            </div>
            <div className="text-[11px] font-bold text-slate-700 leading-tight">{label}</div>
            <div className="text-[10px] text-slate-400 font-medium truncate">{sub}</div>
        </div>
    );
}

export function ChartCard({ title, icon, children, className = '' }) {
    return (
        <div
            className={`bg-white rounded-2xl border border-slate-100 overflow-hidden ${className}`}
            style={{ boxShadow: '0 1px 4px rgba(10,37,64,0.06)' }}
        >
            <div className="flex items-center gap-2 px-5 pt-4 pb-3 border-b border-slate-50">
                <span className="text-slate-400">{icon}</span>
                <h3 className="text-[11px] font-black text-slate-700 uppercase tracking-widest">{title}</h3>
            </div>
            <div className="p-4">{children}</div>
        </div>
    );
}